module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"Recomendado":"Recomendado","Cine":"Cine","Música":" Música","Libro":"Libro","Serie":"Serie","Documental":"Documental","Juego":"Juego"},"en":{"Recomendado":"Recommended"},"ca":{"Recomendado":"Recomanat","Cine":"Cinema","Música":"Música","Libro":"Llibre","Serie":"Serie","Documental":"Documental","Juego":"Joc"}}')
  delete Component.options._Ctor
}
